import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.BlackPanthera,
  voices: {
    main: {
      description:
        "sleek young royal baritone, crisp pan-African courtly cadence, feline calm under sudden attack energy, velvet low mids, polished close studio tone",
      seed: 10289,
      guidance: 0.76,
      loudness: 0.78,
    },
  },
  lines: {
    select: [
      { id: "select_1", text: "Are you ready to hunt?" },
      { id: "select_2", text: "Greetings, I am Black Panthera of Wakanda." },
      { id: "select_3", text: "I am T'Challa, the Black Panthera." },
      { id: "select_4", text: "Wakanda answers the call to battle!" },
    ],
    spawn: [
      {
        id: "spawn_1",
        text: "Bast is not the only Goddess who has blessed me this day…",
      },
      { id: "spawn_2", text: "With you by my side, Ororo, I can never lose." },
      {
        id: "spawn_3",
        text: "I shall retrace my path, and follow it to victory!",
      },
      {
        id: "spawn_4",
        text: "A strategic alliance, between Limbo and Wakanda!",
      },
      {
        id: "spawn_5",
        text: "My father would have loved to see Wakanda reaching across the stars.",
      },
      { id: "spawn_6", text: "It is a dark jungle out there in the universe." },
      {
        id: "spawn_7",
        text: "Science and faith, of course they can co-exist.",
      },
      {
        id: "spawn_8",
        text: "Bringing Wakanda to the stars was a dream of mine since youth.",
      },
      { id: "spawn_9", text: "My people look forward to the afterlife…" },
      {
        id: "spawn_10",
        text: "One must first be afraid. Bravery comes only after fear.",
      },
      {
        id: "spawn_11",
        text: "If only the Dora Milaje were here… But you will have to do.",
      },
      {
        id: "spawn_12",
        text: "My empire will not fall. Not by Doom's hand or any other.",
      },
      {
        id: "spawn_13",
        text: "Wakanda has always reached for the stars. Now we have claimed them.",
      },
      {
        id: "spawn_14",
        text: "No true king makes decisions only for himself.",
      },
      { id: "spawn_15", text: "Welcome to the jungle, you are my prey." },
      { id: "spawn_16", text: "I am king of my people, guard of our gods." },
      { id: "spawn_17", text: "Wakanda Forever!" },
      { id: "spawn_18", text: "I was chosen by Bast. Let me show you why." },
      {
        id: "spawn_19",
        text: "My claws may be sharp, but my mind is far sharper.",
      },
      { id: "spawn_20", text: "Enemies, beware. The panther is on the prowl." },
    ],
    respawn: [
      { id: "respawn_1", text: "Djalia can wait! The hunt is not over!" },
      { id: "respawn_2", text: "Bast has favored me with another chance." },
      { id: "respawn_3", text: "Again! My ancestors are watching." },
      {
        id: "respawn_4",
        text: "Lesson learned. Let's try something different.",
      },
      { id: "respawn_5", text: "We are only given so many chances to shine." },
      { id: "respawn_6", text: "I have returned from Djalia." },
      { id: "respawn_7", text: "My soul shall not rest yet." },
      { id: "respawn_8", text: "I still have some hunt left in me." },
    ],
    ult_ally: [{ id: "ult_ally", text: "Bast, grace us with victory!" }],
    ult_enemy: [{ id: "ult_enemy", text: "Tremble before Bast!" }],
    secondary: [
      { id: "secondary_1", text: "Ha! My aim is true." },
      { id: "secondary_2", text: "Bast guide my spear." },
      { id: "secondary_3", text: "Hit!" },
    ],
    kill: [
      { id: "kill_1", text: "Honor the Panther Cult!" },
      { id: "kill_2", text: "For Wakanda!" },
      { id: "kill_3", text: "For Bast!" },
      { id: "kill_4", text: "Know your limits." },
      { id: "kill_5", text: "We each must do our part." },
      { id: "kill_6", text: "You were not blessed." },
      { id: "kill_7", text: "Victory belongs to Wakanda." },
      { id: "kill_8", text: "I am your king now." },
      { id: "kill_9", text: "Far too simple a victory." },
      { id: "kill_10", text: "You have brought shame upon yourself." },
      { id: "kill_11", text: "Clearly, you were outmatched." },
    ],
    multikill: [
      { id: "multikill_1", text: "Three. Excellent." },
      { id: "multikill_2", text: "Three foes defeated." },
      { id: "multikill_3", text: "A trio of victories." },
      { id: "multikill_4", text: "I believe that makes five." },
      { id: "multikill_5", text: "Five? An adequate number." },
      { id: "multikill_6", text: "Many have fallen at my hand." },
      { id: "multikill_7", text: "I have defeated them all." },
      { id: "multikill_8", text: "No foe has been left standing." },
      { id: "multikill_9", text: "All have fallen by my hand." },
    ],
    low_hp: [
      { id: "low_hp_1", text: "Health! Bast be praised!" },
      { id: "low_hp_2", text: "This will not be my last battle after all." },
    ],
    healed: [
      { id: "healed_1", text: "Ah, yes. Much better." },
      { id: "healed_2", text: "My strength is renewed." },
      { id: "healed_3", text: "Powerful healing." },
      { id: "healed_4", text: "Tastes like the Heart-shaped Herb!" },
    ],
  },
} satisfies VoiceScript;

export default script;
